import styled from 'styled-components';

export const PricingPlansStyled = styled.div`
  width: 100%;
`;

export const ContainerStyled = styled.div`
  max-width: 1300px;
  margin: 0 auto;
  padding: 30px 18.5px;
  display: flex;
  flex-direction: column;
  gap: 40px;

  .headings {
    display: flex;
    justify-content: center;
    align-items: center;
    gap: 30px;
    flex-direction: column;
  }
  .main-text {
    display: flex;
    flex-direction: column;
    text-align: center;
    justify-content: center;
    align-items: center;
    gap: 14px;

    & .heading {
      font-size: 18px;
      line-height: 32px;
      @media (min-width: ${({ theme }) => theme.breakpoints.md}) {
        font-size: 24px;
        line-height: 50px;
      }
      @media (min-width: ${({ theme }) => theme.breakpoints.lg}) {
        font-size: 32px;
      }
    }
    & .text {
      font-size: 14px;
      line-height: 25px;
      text-align: center;
      @media (min-width: ${({ theme }) => theme.breakpoints.md}) {
        font-size: 16px;
        line-height: 32px;
      }
      @media (min-width: ${({ theme }) => theme.breakpoints.lg}) {
        font-size: 20px;
      }
    }
  }

  .btns-text {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    gap: 20px;

    & .btns {
      display: flex;
      gap: 12px;

      & .btn {
        border-radius: 20px;
      }
    }
  }

  .card-container {
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
    gap: 30px;
  }
`;

export const PlansCardStyled = styled.div<{ $isRecommend: boolean }>`
  border-radius: 10px;
  background-color: ${({ theme, $isRecommend }) =>
    $isRecommend ? theme.colors.landingSecondaryText : theme.colors.popoverBg};
  padding: 30px 20px;
  display: flex;
  flex-direction: column;
  gap: 30px;

  & p {
    color: ${({ theme, $isRecommend }) =>
    $isRecommend ? theme.colors.white : theme.colors.darkText};
  }

  .main-text {
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    align-items: flex-start;
    position: relative;
    gap: 16px;

    & .recommend {
      position: absolute;
      right: 0;
      top: 0;
      background-color: ${({ theme }) => theme.colors.white};
      color: ${({ theme }) => theme.colors.landingSecondaryText};
      padding: 6px 10px;
      border-radius: 20px;
      font-weight: 600;
      size: 14px;
      line-height: 16.94px;
    }
  }

  .merits {
    display: flex;
    flex-direction: column;
    gap: 16px;
    & .merits-icon {
      display: flex;
      align-items: center;
      gap: 7px;

      & p {
        font-weight: 500;
        font-size: 14px;
        line-height: 25px;
      }
    }
  }
`;
